import {
  HTTP_INSERTPROJECT_FETCHING,
  HTTP_INSERTPROJECT_SUCCESS,
  HTTP_INSERTPROJECT_FAILED,
} from "./../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_INSERTPROJECT_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_INSERTPROJECT_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_INSERTPROJECT_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
